export default __webpack_public_path__ + "static/media/pdf2.10c64bf7.png";